import { createAsync, A } from "@solidjs/router"
import {  createSignal, For, Show } from "solid-js";

//import TimeAgo from 'javascript-time-ago'
//import en from 'javascript-time-ago/locale/en'

//TimeAgo.addDefaultLocale( en );

import { formattedTimestamp } from "~/lib";

import { createCognitoUser, findCognitoUserByEmail, updateDB } from "~/_server";

import { getByRowType } from "~/lib/queries";

const capitalize = ( str: string ) =>
	str.charAt( 0 ).toUpperCase() + str.slice( 1 ).toLowerCase();

const NOW = Date.now();
const MONTH_IN_SECONDS = 1000  * 60 * 60 * 24 * 28;
const BASE_DATE = NOW - ( MONTH_IN_SECONDS * 12 * 30 );


type UserSort = 'name' | 'lastLogin' | 'email' | 'role' | 'status' | 'registered';

export const Subscriptions = props => {
	const [filter, setFilter] = createSignal( '' );
	const [sort, setSort] = createSignal<UserSort>( 'registered' );
	const [sortDir, setSortDir] = createSignal<'asc' | 'desc'>( 'desc' );
	const [timeLimit, setTimeLimit] = createSignal( NOW - ( MONTH_IN_SECONDS * 1 ) );

	//const timeAgo = new TimeAgo( 'en-GB' );

	const subs	= createAsync( () => getByRowType( 'SUBSCRIPTION', 9999, "pk, sk, #name, #status, registered, joined, scheme", { '#name': 'name', '#status': 'status' } ).then( r => r?.items ?? [] ) );
	
	/*
	const filteredUsers = createMemo( () => users()?.filter( u => {
		if ( filter() != "" ) {
			if ( u.name.toLowerCase().includes( filter().toLowerCase() ) || u.email.toLowerCase().includes( filter().toLowerCase() ) ) return true;
		} else {

			console.log( "Filtering user", ( u.lastLogin ?? BASE_DATE ), timeLimit(), ( u.lastLogin ?? BASE_DATE ) >= timeLimit() );
			if ( ( u.lastLogin ?? BASE_DATE ) >= timeLimit() ) return true;
		}

		return false;
	} ) );

	const sortedUsers = createMemo( () => filteredUsers()?.sort( ( a, b ) => {
		switch( sort() ) {
			case 'name':
				return a.lastName.localeCompare( b.lastName ) || a.firstName.localeCompare( b.firstName );
			
			default:
				return ( b[sort()] ?? 0 ) - ( a[sort()] ?? 0 );
		}
	} ) );*/
	
	return ( <div class="px-4 sm:px-6 lg:px-8">
		<div class="sm:flex sm:items-center">
			<div class="sm:flex-auto">
				<h1 class="text-base font-semibold text-gray-900">Subscriptions</h1>
			</div>
		</div>

		<div class="sm:flex sm:items-center text-sm mt-2">
			Filter: <input title="Search users" onInput={e => setFilter( e.target.value )} type="text" class="block rounded-md min-w-2xl ml-2 bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 w-10" />

		</div>

		<div class="mt-8 flow-root">
			<div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
				<div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
					<table class="relative min-w-full divide-y divide-gray-300">
						<thead>
							<tr class="even:bg-gray-50">
								<th scope="col" class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-0">
									<a href="#" class="group inline-flex">
										Name
										<span class="ml-2 flex-none rounded-sm bg-gray-100 text-gray-900 group-hover:bg-gray-200">
											<svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
												<path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
											</svg>
										</span>
									</a>
								</th>
								<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Last Login</th>
								<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Email</th>
								<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Role</th>
								<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Status</th>
								<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Registered</th>
								<th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Access</th>
							</tr>
						</thead>
						<tbody class="divide-y divide-gray-200">
							<For each={subs()}>
								{
									sub => (
										<tr class="even:bg-gray-50">
											<td class="py-4 pr-3 pl-4 text-sm font-medium text-gray-900 sm:pl-0"><A href={`/dashboard/admin/users/${sub?.userId}`}>{sub?.name}</A> (#{sub?.userId})</td>
											<td class="px-3 py-4 text-sm text-gray-500">{sub?.email}</td>
											<td class="px-3 py-4 text-sm text-gray-500">{JSON.stringify( sub?.roles )}</td>
											<td class="px-3 py-4 text-sm text-gray-500">{sub?.status}</td>
											<td class="px-3 py-4 text-sm text-gray-500">{sub?.joined   && formattedTimestamp( sub.joined )}</td>
											<td class="px-3 py-4 text-sm text-gray-500">
												<Show when={sub?.sub}>
													✅
												</Show>
												<Show when={!sub?.sub}>
													<span onClick={async () => {
														let cognitoUser = await findCognitoUserByEmail( sub?.email );
														if ( !cognitoUser?.Attributes ) {
															cognitoUser = await createCognitoUser( sub?.email, sub?.lastName, sub?.firstName, sub?.userId );
														}

														if ( cognitoUser?.Attributes ) {
															const cognitoSub = cognitoUser.Attributes.find( a => a.Name == 'sub' )?.Value;

															if ( cognitoSub ) {
																await updateDB(
																	`USER#${sub?.userId}`,
																	sub?.sk,
																	{ sub: cognitoSub }
																);
															}
														}

														//revalidate( users.key);
													}
													}>➕</span>

												</Show>
											</td>
										</tr>
									)
								}
							</For>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div> );
}